module.exports = __webpack_public_path__ + "static/media/cialis-10mg.123cf61a.png";